import styled from "styled-components";
export default {
    AudioSegments: styled.div.attrs({
        className: "flex-space-between bg-gray-650 mb-2"
    }) `
    overflow: hidden;

    button {
      box-sizing: border-box !important;
      background-color: ${({ theme }) => theme["gray-650"]};
      color: #fff;
      border: none;
      margin: 0;
      border-left: 1px solid white;

      &.selected {
        background-color: ${({ theme }) => theme["brand-warning-400"]}20;
        border-left: 1px solid ${({ theme }) => theme["brand-warning-400"]};
        margin-left: 0;
        margin-right: 0;
      }

      &.selected + button {
        border-left: 1px solid ${({ theme }) => theme["brand-warning-400"]};
      }

      &:last-child {
        border-right: 1px solid white;
      }

      &.selected:last-child {
        border-right: 1px solid ${({ theme }) => theme["brand-warning-400"]};
      }
    }
  `
};
